import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const BaseballHat: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <g clipPath="url(#clip0_507_581)">
                <IconPath
                    d="M17.535 12.768L3.35301 17.655C2.97693 17.7843 2.56489 17.759 2.20747 17.5846C1.85006 17.4102 1.57653 17.101 1.44701 16.725L1.20001 16.016C0.487246 13.9473 0.625453 11.6802 1.58423 9.71341C2.54301 7.74663 4.24383 6.24127 6.31251 5.5285C8.3812 4.81573 10.6483 4.95394 12.6151 5.91272C14.5819 6.8715 16.0872 8.57231 16.8 10.641L17.535 12.768ZM17.535 12.768L22.294 14.5C22.5523 14.6006 22.7776 14.7708 22.945 14.9917C23.1124 15.2126 23.2153 15.4755 23.2423 15.7513C23.2693 16.0272 23.2194 16.3051 23.0981 16.5543C22.9768 16.8035 22.7888 17.0142 22.555 17.163C20.7651 18.2678 18.7122 18.8737 16.6092 18.9179C14.5062 18.962 12.4297 18.4428 10.595 17.414L8.14701 16M6.31501 5.529C6.31501 5.529 10.525 7.822 11.749 14.762"
                    {...pathProps}
                />
            </g>
            <defs>
                <clipPath id="clip0_507_581">
                    <rect width="24" height="24" fill="transparent" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
